export enum STORAGE_KEYS {
    TOKEN = 'token',
    SIGNUP_TOKEN = 'signup-token',
    REMEMBER_ME = 'rememberMe',
    USER = 'user',
}

export enum REDUCER_ENUMS {
  AUTH_USER_LOGIN = 'user-login',
  FORGET_PASSWORD = 'forgot-password',
  VERIFY_EMAIL = 'verify-email',
  RESEND_EMAIL_OTP = 'resend-email-otp',
  CHANGE_PASSWORD = 'change-password',
  RESET_PASSWORD = 'reset-password',
  AUTH_SIGNUP = 'auth-signup',
  AUTH_LOGOUT = 'auth-logout',
  CLEAR = 'clear',
  VERIFY_OTP = 'verify-otp',
  RESEND_OTP = 'resend-otp',
  GOOGLE_SIGN_IN = 'google-sign-in',
  ANNUAL_REVENUE = 'annual-revenue',
  INDUSTRY_TYPE = 'industry',
  COMPANY_SIZE = 'company-size',
  COMPANY_PROFILE = 'company-profile',
  USER_PROFILE = 'user-profile',
  ADMIN_USERS_LIST = 'admin-users-list',
  ADMIN_USERS_FILTERS = 'admin-users-filters',
  CLEAR_FILTERS = 'clear-filters',
  TIERS = 'tiers',
  USER_PROFILE_ACTION = 'user-profile-action',
  ADD_TIER_ACTION = 'add-tier-action',
  ADMIN_TIERS_FILTERS = 'admin-tiers-filters',
  ADMIN_TIERS_LIST = 'admin-tiers-list',
  UPDATE_TIER_ACTION = 'update-tier-action',
  ADMIN_DASHBOARD_ANALYTICS = 'admin-dashboard-analytics',
  AI_UPLOAD_DOC = 'ai-upload-doc',
  DELETE_USER = 'delete-user'
}

export enum PROFILE_STATUS {
  ACCOUNT_VERIFICATION_IN_PROGRESS = '1',
  PROFILE_IN_PROGRESS = '2',
  ADMIN_VERIFICATION_IN_PROGRESS = '3',
  ADMIN_REJECTED = '4',
  COMPLETED = '5',
  INACTIVE = '6',
}

export enum USER_TYPE {
  EMPLOYER = '1',
  CANDIDATE = '2',
  ADMIN = '3',
  SUPER_ADMIN = '4',
}
